/**
 * Chat Empty State - Shown when no conversation is selected
 */

import { useTranslation } from 'react-i18next';
import { MessageSquarePlus } from 'lucide-react';
import { EmptyState } from '@/components/v2/ui';

interface Props {
  onNewConversation: () => void;
}

export function ChatEmptyState({ onNewConversation }: Props) {
  const { t } = useTranslation();

  return (
    <EmptyState
      icon={<MessageSquarePlus className="h-12 w-12" />}
      title={t('chatImage.emptyTitle')}
      description={t('chatImage.emptyDescription')}
      action={
        <button
          onClick={onNewConversation}
          className="rounded-lg bg-primary-600 px-4 py-2 text-sm font-medium text-white hover:bg-primary-700 transition-colors"
        >
          {t('chatImage.newConversation')}
        </button>
      }
    />
  );
}
